import { Action } from 'redux';

import ActionPayloadBoolean from '../interfaces/actions/ActionPayloadBoolean';
import ActionPayloadString from '../interfaces/actions/ActionPayloadString';
import ActionPayloadAny from '../interfaces/actions/ActionPayloadAny';

import * as Const from '../constants';

export const fetchAuthInit = (): Action => {
  return {
    type: Const.AUTH_INIT,
  };
};

export const fetchAuthLoading = (): Action => {
  return {
    type: Const.AUTH_LOADING,
  };
};

export const fetchAuthSuccess = (payload: string): ActionPayloadString => {
  return {
    type: Const.AUTH_SUCCESS,
    payload,
  };
};

export const fetchMountedAuthSuccess = (user: any): ActionPayloadAny => {
  return {
    type: Const.AUTH_MOUNTED_SUCCESS,
    payload: user,
  };
};

export const fetchRefreshToken = (payload: string): ActionPayloadString => {
  return {
    type: Const.AUTH_REFRESH_TOKEN,
    payload,
  };
};

export const fetchAuthFail = (): Action => {
  return {
    type: Const.AUTH_FAIL,
  };
};

export const fetchAuthLoadingSuccess = (isAuth: boolean): ActionPayloadBoolean => {
  return {
    type: Const.AUTH_SUCCESS_LOAD,
    payload: isAuth,
  };
};

export const fetchExitButton = (): Action => {
  return{
    type: Const.AUTH_EXIT,
  };
};

export const fetchAuthErrorMessageInit = (payload: any): ActionPayloadAny => {
  return {
    type: Const.AUTH_ERROR_MESSAGE_INIT,
    payload,
  };
};
